/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_View_AgendaInputs */



/**
* | output |
* | --- |
* | "Your Agenda" |
*
* @param {Tournaments_View_AgendaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_view_agenda = /** @type {((inputs?: Tournaments_View_AgendaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_View_AgendaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre agenda")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su agenda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua agenda")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua agenda")
	return /** @type {LocalizedString} */ ("Your Agenda")
});